import {createMuiTheme} from "@material-ui/core/styles";
import {colors} from "@material-ui/core";

export const DATE_TIME_SUFFIX = "Z"

export const TARGET_REVIEW_STATUS_FOR_DISPLAY_DENIAL_REASON = [
    5
]

export const tableTheme = createMuiTheme({
    palette: {
        primary: {
            main: colors.blue[300],
            light: '#fff',
            contrastText: '#fff',
        },
    },
});

export const MSG = {
    ERR_GET_ADGROUP: "広告グループ情報取得に失敗しました。",
    ERR_GET_CAMPAIGN: "キャンペーン情報取得に失敗しました。",
    ERR_GET_ADVERTISEMENT: "広告情報取得に失敗しました。",
    ERR_GET_ADASSET: "広告アセット情報取得に失敗しました。",
    ERR_POST_ADVERTISEMENT: "広告情報作成に失敗しました。",
    ERR_PUT_ADVERTISEMENT: "広告情報更新に失敗しました。",
    ERR_GET_ASSETS: "広告アセット情報の取得に失敗しました。",
    SUCCESS_POST_ADVERTISEMENT: "広告情報作成に成功しました。",
    SUCCESS_PUT_ADVERTISEMENT: "広告情報更新に成功しました。",
}

export const STATUS_ARCHIVE = 6;

export const AdProcessType = {
    create: "create",
    edit: "edit",
    preview: "preview",
}

export const BLANK = ""
export const ARCHIVE_VALUE_NO = 6

export const INIT_STR = "";
export const INIT_NUMBER = 0;

export const INIT_AD_STATUS = 3;

export const AD_REVIEW_STATUS_BEFORE_REVIEW = 1;

export const TRACKING_PARAMETER_SEPARATE_CHAR = "&";
export const TRACKING_KEY_VALUE_SEPARATE_CHAR = "=";
export const TRACKING_KEY_VALUE_START_CHAR = "?";

export const options_ms_ad_review_state = [
    {value: 1, label: '未審査'},
    {value: 2, label: '審査中'},
    {value: 3, label: '審査OK'},
    {value: 4, label: '条件付きOK'},
    {value: 5, label: '審査NG'},
];

export const options_ms_ad_denial_reason = [
    {value: 1, label: '競合、取扱不可サービス'},
    {value: 2, label: '公序良俗に反する'},
    {value: 3, label: '広告関連法規に反する'},
    {value: 4, label: '媒体基準に反する'},
];

export const RESULT_KBN = {
    SUCCESS: 0,
    INFO: 1,
    ERROR: 9,
}
